import Vue from 'vue'
import VueRouter from 'vue-router'

import LOGIN from '../views/login/login.vue'
//------------------------------------------------------------- 

import Layout from '@/layout'



Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: INDEX,

  //   meta: {
  //     title: "首页",
  //     content: "首页"
  //   },
  //   redirect: "/home",
  //   children: [{
  //     path: '/homePage',
  //     name: 'homePage',
  //     component: HOME,
  //     meta: {
  //       title: "首页",
  //       content: "首页"
  //     }
  //   }, ]
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    alwaysShow: true, // will always show the root menu
    name: 'indexPage',
    children: [{
      path: 'index',
      component: () => import('@/views/index/index'),
      name: 'index',
      meta: {
        title: '售票',
      }
    },
    {
      path: 'refundTicket',
      component: () => import('@/views/index/refundTicket'),
      name: 'refundTicket',
      meta: {
        title: '退票',
      }
    },
    {
      path: 'detailUser',
      component: () => import('@/views/index/detailUser'),
      name: 'detailUser',
      meta: {
        title: '会员',
      }
    },
    {
      path: 'userList',
      component: () => import('@/views/index/userList'),
      name: 'userList',
      meta: {
        title: '会员列表',
        belong: '/detailUser',
      }
    },
    {
      path: 'payCard',
      component: () => import('@/views/index/payCard'),
      name: 'payCard',
      meta: {
        title: '售卡',
        belong: '/detailUser',
      }
    },

    {
      path: 'orderList',
      component: () => import('@/views/index/orderList'),
      name: 'detailUser',
      meta: {
        title: '订单',//用户设置
        proName: '',
        breadNumber: 2,
        belong: 1,//tab的id
      }
    },
    {
      path: 'makeup',
      component: () => import('@/views/index/makeup'),
      name: 'detailUser',
      meta: {
        title: '补打',//用户设置
      }
    },
    {
      path: 'shift',
      component: () => import('@/views/index/shift'),
      name: 'shift',
      meta: {
        title: '交班',//用户设置
      }
    }, {
      path: 'statement',
      component: () => import('@/views/index/statement'),
      name: 'statement',
      meta: {
        title: '报表',//用户设置
      }
    }]
  },


  {
    path: '/system',
    component: Layout,
    redirect: '/system/system',
    alwaysShow: true, // will always show the root menu
    name: 'system',
    children: [{
      path: 'system',
      component: () => import('@/views/system/system'),
      name: 'system_system',
      meta: {
        title: '系统设置',
        breadNumber: 1,
        belong: 6,//tab的id
      }
    },
    {
      path: 'manage_list',
      component: () => import('@/views/system/manage_list'),
      name: 'manage_list',
      meta: {
        title: '系统管理员',
        breadNumber: 1,
        belong: 6,//tab的id
      }
    }, {
      path: 'password',
      component: () => import('@/views/system/password'),
      name: 'password',
      meta: {
        title: '修改密码',
        breadNumber: 1,
        belong: 6,//tab的id
      }
    },
    ]
  },




  {
    path: "/login",
    name: "login",
    component: LOGIN,
    meta: {
      title: "登录",
      content: "登录",
      mustLogin: false
    },
  },
  // {
  //   path: "/login1",
  //   name: "login1",
  //   component: () =>
  //     import('@/views/login/login1'),
  //   meta: {
  //     title: "登录",
  //     content: "登录"
  //   },
  // },
  //-------------------------------------------------------------------------------

]

const router = new VueRouter({
  // mode: 'history',
  routes: routes,

  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
const routerPush = router.push;
router.push = path => {
  // 判断下当前路由是否就是要跳转的路由
  if (router.currentRoute.fullPath.includes(path)) return;
  return routerPush.call(router, path);
}


import { getToken } from "@/utils/auth"

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const TOKEN = getToken()
  // const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : false;
  if (to.meta && to.meta.mustLogin !== false && !TOKEN) {
    next({
      path: '/login'
    })
  } else {

    next()
  }

})



export default router